import {styled} from "@mui/material"
import {makeStyles} from "@mui/styles"

export const Counter = styled("span")(() => ({
	background: "#CBB78B",
	width: "2rem",
	height: "2rem",
	display: "grid",
	placeItems: "center",

	fontSize: "1.2rem",
	fontStyle: "normal",
	fontWeight: 600,
	lineHeight: "166%",

	position: "absolute",
	top: 0,
	right: "-0.4rem",
	borderRadius: "50%"
}))

export const useTooltipStyles = makeStyles({
	tooltip: {
		// TODO: Find a better way to overwrite/reset styles coming from UI-kit
	}
})

export const PositionContainer = styled("div")(({theme: {typography}}) => ({
	position: "absolute",
	right: typography.pxToRem(32),
	top: "6.2rem"
}))